export const DIALOGS = {
    PIN : 'pin',
    FORWARD : 'forward',
}